import React, { useState, useEffect, useCallback } from "react";

import { Table, Space, Button, Popconfirm, Row } from "antd";

import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";

import { SearchColumn } from "../../../../components/SearchColumn/SearchColumn";

import { ModalAdd } from "./components/ModalAdd";
import { openNotification } from "../../../../components/Notification";
import { sexualidadeService } from "../../../../services/resources/sexualidadeService";

export const Sexualidade = () => {
  const [sexualidade, setSexualidade] = useState([]);

  const [openModal, setOpenModal] = useState(false);

  const [codigo, setCodigo] = useState(null);
  const [codigoDelete, setCodigoDelete] = useState(null);
  const [mode, setMode] = useState("");

  const [disabled, setDisabled] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    getSexualidade();
    // eslint-disable-next-line
  }, []);

  async function getSexualidade() {
    try {
      const { data } = await sexualidadeService.load();
      transformList(data);
    } catch (error) {
      openNotification(
        "error",
        <strong>Ocorreu um erro ao buscar a lista de Orientações Sexuais!</strong>,
        error?.response?.data?.detail
      );
    }
  }

  async function handleDelete(codigo) {
    setConfirmLoading(true);
    setDisabled(true);
    try {
      await sexualidadeService.delete(codigo);
      openNotification("success", <strong>Orientação Sexual excluída!</strong>);
      getSexualidade();
    } catch (reason) {
      openNotification(
        "error",
        <strong>Não foi possível excluir a Orientação Sexual!</strong>,
        reason?.response?.data?.detail
      );
    } finally {
      setCodigoDelete(null);
      setConfirmLoading(false);
      setDisabled(false);
    }
  }

  const handleOpenModal = useCallback((sexualidade) => {
    setOpenModal(true);
    setCodigo(sexualidade?.codigo);
  }, []);

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
  }, []);

  const transformList = useCallback((list) => {
    list.sort(function (a, b) {
      return a.descricao > b.descricao ? 1 : b.descricao > a.descricao ? -1 : 0;
    });
    setSexualidade(list);
  }, []);

  const renderTable = () => {
    const columns = [
      {
        title: <strong>Descrição</strong>,
        dataIndex: "descricao",
        key: "descricao",
        ...SearchColumn("descricao"),
      },
      {
        title: <strong>ações</strong>,
        key: "action",
        width: 64,
        render: (sexualidade) => (
          <Space size="small">
            <Button
              type="primary"
              className="action-button"
              ghost
              title={`Visualizar orientação sexual ${sexualidade?.descricao}`}
              onClick={() => {
                handleOpenModal(sexualidade);
                setMode("onView");
              }}
            >
              <EyeOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
            <Button
              type="primary"
              className="action-button"
              title={`Editar agravante ${sexualidade?.descricao}`}
              onClick={() => {
                handleOpenModal(sexualidade);
                setMode("onEdit");
              }}
            >
              <EditOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
            <div>
              <Popconfirm
                title={
                  <span>
                    excluir orientação sexual <strong>{sexualidade?.descricao}</strong>?"
                  </span>
                }
                visible={sexualidade?.codigo === codigoDelete}
                placement="bottomRight"
                okText="confirmar exclusão"
                cancelText="cancelar"
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                onConfirm={() => handleDelete(sexualidade?.codigo)}
                onCancel={() => setCodigoDelete(null)}
                okButtonProps={{ loading: confirmLoading }}
                disabled={disabled}
                cancelButtonProps={{ disabled: disabled }}
              >
                <Button
                  type="danger"
                  className="action-button"
                  title={`Excluir Orientação Sexual ${sexualidade?.descricao}`}
                  onClick={() => {
                    setCodigoDelete(sexualidade?.codigo);
                  }}
                >
                  <DeleteOutlined style={{ fontSize: "1.2rem" }} />
                </Button>
              </Popconfirm>
            </div>
          </Space>
        ),
      },
    ];
    function showTotal(total) {
      return (
        <>
          Total de <strong>{total}</strong> Orientações Sexuais
        </>
      );
    }
    return (
      <Table
        dataSource={sexualidade}
        columns={columns}
        size="small"
        rowKey={({ codigo }) => codigo}
        pagination={{
          size: "small",
          total: sexualidade?.length,
          showSizeChanger: true,
          showTotal: showTotal,
        }}
      />
    );
  };

  return (
    <>
      <div className="container-section">
        <Row id="header">
          <h2>LISTA DE ORIENTAÇÕES SEXUAIS</h2>

          <Button
            type="primary"
            onClick={() => {
              handleOpenModal(null);
              setMode("onCreate");
            }}
          >
            nova Orientação Sexual
          </Button>
        </Row>
        {renderTable()}
      </div>

      {openModal && (
        <ModalAdd
          onClose={handleCloseModal}
          codigo={codigo}
          mode={mode}
          reload={getSexualidade}
        />
      )}
    </>
  );
};
